import _ from 'lodash';
import { makeCell } from './gridUtill';
let fields = [];
let columns = [];

// // 용매조성코드 컬럼 추가
// makeCell(
//   1,
//   [
//     {
//       field: 'code',
//       alias: '용매조성코드',
//       indexExclusive: true,
//       visible: true, // 숨김 컬럼으로 설정 (백엔드에서 받아오는 데이터와 맵핑용)
//     },
//   ],
//   fields,
//   columns,
// );

// makeCell(
//   1,
//   [
//     {
//       field: 'idx',
//       indexExclusive: true,
//     },
//   ],
//   fields,
//   columns,
// );
// makeCell(
//   1,
//   [
//     {
//       field: 'ww',
//       alias: 'w/w',
//       indexExclusive: true,
//     },
//   ],
//   fields,
//   columns,
// );
makeCell(
  8,
  [
    {
      field: 'solvent',
      alias: 'solvent',
    },
    {
      field: 'solventVol',
      alias: 'wt%',
      excelKey: 'wt%_',
    },
  ],
  fields,
  columns,
);
makeCell(
  5,
  [
    {
      field: 'salt',
      alias: 'salt',
    },
    {
      field: 'saltVol',
      alias: 'wt%',
      excelKey: 'wt%_',
    },
  ],
  fields,
  columns,
);
// makeCell(
//   1,
//   [
//     {
//       field: 'density',
//       alias: '밀도',
//       indexExclusive: true,
//     },
//   ],
//   fields,
//   columns,
// );
// makeCell(
//   1,
//   [
//     {
//       field: "sum",
//       alias: "SUM",
//       indexExclusive: true,
//     },
//   ],
//   fields,
//   columns
// );
makeCell(
  1,
  [
    {
      field: 'sum',
      alias: 'sum',
      indexExclusive: true,
    },
  ],
  fields,
  columns,
);

const rowSet = _.reduce(
  fields,
  (a, v) => {
    if (v.excelKey) {
      a.push({
        key: v.fieldName,
        value: v.excelKey,
      });
    }
    return a;
  },
  [],
);
export { fields, columns, rowSet };
